export const BLOG_AUDIO_MODULE_PATH = '@hubspot/blog_audio';

// sanity limit, ~10x what OpenAI whisper allows at once
export const INPUT_CHAR_LIMIT = 40000;
export const POST_NARRATION_TRANSCRIPTS_FOLDER = 'post-narration-transcripts';
export const UPGRADE_POINT_KEY = 'blog-post-narration';
export const Voices = {
  ALLOY: 'ALLOY',
  ECHO: 'ECHO',
  FABLE: 'FABLE',
  ONYX: 'ONYX',
  NOVA: 'NOVA',
  SHIMMER: 'SHIMMER'
};